import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { BarrierDto } from '../../../../../api/gen';
import { ZoneBarrierCommandsComponent } from './zone-barrier-commands/zone-barrier-commands.component';

@Component({
  selector: 'app-zone-barrier',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule, ZoneBarrierCommandsComponent],
  templateUrl: './zone-barrier.component.html',
  styleUrl: './zone-barrier.component.scss'
})
export class ZoneBarrierComponent {
  @Input() barrier!: BarrierDto;
  @Input() isProcessing = false;
  @Output() deleteBarrier = new EventEmitter<string>();
  @Output() editBarrier = new EventEmitter<BarrierDto>();
  @Output() unassignBarrier = new EventEmitter<string>();

  onDelete(): void {
    if (this.barrier?.id) {
      this.deleteBarrier.emit(this.barrier.id);
    }
  }

  onEdit(): void {
    if (this.barrier) {
      this.editBarrier.emit(this.barrier);
    }
  }

  onUnassign(): void {
    if (this.barrier?.id) {
      this.unassignBarrier.emit(this.barrier.id);
    }
  }

}
